import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/LinkSimple.es.js";
const o = e.forwardRef((i, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...i, weights: t }));
o.displayName = "LinkSimpleIcon";
const p = o;
export {
  p as LinkSimple,
  o as LinkSimpleIcon
};
